import axios from "../api/api";

const deleteCustomer = async (id) => {
  const response = await axios.delete(`/customer?id=${id}`, {
    headers: {
      "Content-Type": "text/plain",
      Accept: "application/json, text/plain, */*",
    },
  });

  return response;
};

export default deleteCustomer;